import React, { useState, useEffect } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  PENDING,
  RNC,
  RNCPENDING,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import ApprovalContainer from "./ApprovalContainer";
function ApprovalIndex({ onClose, onSuccess }) {
  const [clientPendingList, setClientPendingList] = useState([]);

  const role = secureStorage.getItem(SS_ROLE);

  const getAllApprovalList = () => {
    ApiRequestGet.getAllClientList({
      status: role === RNC ? RNCPENDING : PENDING,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setClientPendingList(res.data);
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getAllApprovalList();
  }, []);

  return (
    <div
      style={{ width: "100%", maxHeight: 600, overflow: "auto" }}
      className="hide-scroll-bar"
    >
      {clientPendingList &&
        clientPendingList?.map((res, i) => (
          <ApprovalContainer
            key={i}
            data={res}
            onClose={onClose}
            id={i}
            onSuccess={onSuccess}
          />
        ))}

      {clientPendingList?.length === 0 && (
        <div
          style={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: 12,
            }}
          >
            No requests found
          </p>
        </div>
      )}
    </div>
  );
}

export default ApprovalIndex;
